import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { fetchHealth } from '@/lib/api/health';

const REFRESH_MS = 5 * 60_000;

/**
 * PRD VS-004: the deployed version, read from the running API's /health
 * (TechSpec §14.3) — the exact tag a rollback would take.
 */
export function VersionFooter() {
  const { t } = useTranslation('common');
  const { data, isError } = useQuery({
    queryKey: ['health', 'version'],
    queryFn: () => fetchHealth(),
    staleTime: REFRESH_MS,
    refetchInterval: REFRESH_MS,
  });

  let text: string;
  if (data) text = t('footer.version', { version: data.version });
  else if (isError) text = t('footer.versionUnknown');
  else text = t('footer.versionLoading');

  return (
    <footer className="border-t px-6 py-2 text-xs text-muted-foreground">
      <span className="font-mono">{text}</span>
    </footer>
  );
}
